<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="heading">
        Average Local Ranking <small>({{ type }})</small>
      </h3>
      <a
        v-if="!editing && !preview"
        class="btn primary_btn btn_sm"
        href="/local/gmb/rankings"
      >
        See More
      </a>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <button
          v-if="widget.editable"
          class="btn btn_sm btn-info"
          @click="$parent.edit(widget)"
        >
          Options
        </button>
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove(widget)"
        >
          Delete
        </button>
      </div>
    </div>
    <apexchart
      v-if="!loading && !error"
      :options="chartOptions"
      :series="series"
      height="300"
      type="line"
    />

    <div
      v-if="loading && !error"
      class="loading_widget_data"
    >
      <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
    </div>

    <div
      v-if="error"
      class="widget_error"
      v-html="error"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';
import _ from 'lodash';

export default {
  props: {
    widget: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      error: null,
      type: 'Maps',
      series: [{
        name: "Desktops",
        data: []
      }],
      options: {
        colors: ['#0c9bef', '#969696'],
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
          type: 'datetime',
        },
        yaxis: {
          reversed: true,
          min: 1,
          max: 100,
          forceNiceScale: true
        },
        tooltip: {}
      },
    }
  },
  computed: {
    ...mapState('dashboard', ['chartBaseOptions', 'uuid', 'preview']),
    chartOptions() {
      return {
        ...this.chartBaseOptions,
        ...this.options
      };
    }
  },
  watch: {
    'widget.average_type': {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.fetchData();
      }
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.type = this.widget.average_type;
      this.loading = true;
      axios.post('/ajax/dashboard/get-widget-data', {
        type: 'averageLocalRanking',
        average_type: this.widget.average_type,
        uuid: this.uuid,
      }).then(response => {
        let tempType = this.type;
        this.series[0].name = this.widget.average_type;
        this.series[0].data = response.data.data;
        this.options.xaxis.categories = response.data.labels;
        this.options.yaxis.max = tempType === 'Maps' ? 100 : 3;
        this.options.yaxis.tickAmount = tempType === 'Maps' ? 6 : 2;
        this.options.tooltip = {
          y: {
            formatter: function (value) {
              if (value === 101) {
                // For Map Results data, if 101 returned, display as '>100'
                return `${tempType === 'Maps' ? '>100' : '>3'}`;
              }
              return value;
            }
          },
          x: {
            format: 'd MMM yyyy',
          }
        };
        this.loading = false;
      }).catch(error => {
        this.error = error.response.data;
        this.loading = false;
      });
    }
  },
}
</script>
